import {BI_ORIGINS, ExperimentNames} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import React, {useEffect} from 'react'
import {Divider, Text} from 'wix-ui-tpa/cssVars'
import {usePageActions} from '../../../../hooks/state'
import {shouldShowSeatInfo} from '../../../../selectors/seating/place'
import {OldHeader} from '../../common/old-header'
import {SlideInModal} from '../../slide-in-modal'
import {Ticket} from '../ticket'
import {SeatInfo} from '../ticket/ticket-info/seat-info'
import {classes} from './ticket-description.st.css'
import {TicketDescriptionProps} from './index'

export const TicketDescription = ({
  show,
  place,
  onClose,
  onTicketClick,
  showAccessibilityMode,
}: TicketDescriptionProps) => {
  const {t} = useTranslation()
  const {isMobile} = useEnvironment()
  const {resetAreaCounterValue, selectPlace, unselectPlace} = usePageActions()

  const showSeatInfo = shouldShowSeatInfo(place)
  const description = place?.ticket?.description

  const {experiments} = useExperiments()
  const planTicketsDesignEnabled = experiments.enabled(ExperimentNames.PlanTicketsDesign)

  useEffect(() => {
    if (planTicketsDesignEnabled && !isMobile) {
      if (show && place) {
        selectPlace(place.planPlaceId)
      } else {
        unselectPlace()
      }
    }
  }, [show])

  const getBackButtonText = () => {
    if (isMobile) {
      return
    }

    if (showAccessibilityMode) {
      return t('seatings_moreInfo_backToTicketList')
    }

    return t('seatings_moreInfo_backToBasket')
  }

  const handleOnBackClick = () => {
    onClose()
    resetAreaCounterValue({place})
  }

  return (
    <SlideInModal
      id="ticket-description"
      className={isMobile ? undefined : classes.desktopSlideInModal}
      show={show}
      fromBottom={isMobile}
      onBackClick={isMobile ? undefined : handleOnBackClick}
      backButtonText={getBackButtonText()}
      dataHook={DH.TICKET_DESCRIPTION}
    >
      <div>
        <OldHeader
          className={isMobile ? undefined : classes.desktopHeader}
          titleClassName={isMobile ? undefined : classes.desktopTitle}
          title={t('seatings_moreInfo_title')}
          closeModal={isMobile ? onClose : null}
        />
        <div className={classes.newContent}>
          {place ? (
            <Ticket
              showAccessibilityMode={showAccessibilityMode}
              onClick={onTicketClick}
              place={place}
              origin={BI_ORIGINS.SEATINGS_MODAL_TICKET_DESCRIPTION}
            />
          ) : null}
          {showSeatInfo ? (
            <>
              <SeatInfo inDescription={true} place={place} />
              {description ? <Divider className={classes.divider} /> : null}
            </>
          ) : null}
          {description ? (
            <div className={classes.descriptionContainer}>
              <Text tagName="p" className={classes.descriptionTitle}>
                {t('seatings_moreInfo_ticketDescription')}
              </Text>
              <Text tagName="p" className={classes.description}>
                {description}
              </Text>
            </div>
          ) : null}
        </div>
      </div>
    </SlideInModal>
  )
}
